import React from "react";
import { useTranslation } from "react-i18next";

interface QuoteSummaryProps {
  quoteDetails: {
    name: string;
    email: string;
    phone: string;
    service: string;
    location: string;
    frequency: string;
    bedrooms: number;
    bathrooms: number;
    insideFridge: boolean;
    insideOven: boolean;
    insideCabinets: boolean;
    windows: boolean;
    price: number;
  };
}

const QuoteSummary: React.FC<QuoteSummaryProps> = ({ quoteDetails }) => {


  const { t } = useTranslation();

  return (
    <div className="p-2">
      <h2 className="text-[12px] lg:text-[12px] text-black font-bold mb-4">
        {t("summaryquote.title")}
      </h2>

      <div className="bg-white w-full rounded-sm p-2 mb-4">
        <h2 className="text-[13px] lg:text-[12px] text-textTitle font-bold mb-2">
          {t("summaryquote.personalInfo")}
        </h2>
        <hr className="border-b-1 mb-4" />
        <p className="mb-2 text-[12px] lg:text-[12px] font-semibold text-textTitle">
          {t("summaryquote.date")} {new Date().toLocaleDateString()}
        </p>
        <p className="mb-2 text-[12px] lg:text-[12px] font-semibold text-textTitle">
          {t("summaryquote.name")} {quoteDetails.name || ""}
        </p>
        <p className="mb-2 text-[12px] lg:text-[12px] font-semibold text-textTitle">
          {t("summaryquote.email")} {quoteDetails.email || ""}
        </p>
        <p className="mb-2 text-[12px] lg:text-[12px] font-semibold text-textTitle">
          {t("summaryquote.phone")} {quoteDetails.phone || ""}
        </p>
      </div>

      <div className="bg-white w-full rounded-sm p-2 mb-4">
        <h2 className="text-[13px] lg:text-[12px] text-textTitle font-bold mb-2">
          {t("summaryquote.serviceType")}
        </h2>
        <hr className="border-b-1 mb-4" />
        <p className="mb-2 text-[12px] lg:text-[12px] font-semibold text-textTitle">
        {t("summaryquote.service")} {quoteDetails.service || ""}
        
        </p>
      </div>

      <div className="bg-white w-full flex justify-between rounded-sm p-2 mb-4 pr-8">
    
        <div>
          <h2 className="text-[13px] lg:text-[12px] text-textTitle font-bold mb-2">
            {t("summaryquote.frequency")}
          </h2>
          
          <p className="mb-2 text-[12px] lg:text-[12px] font-semibold text-textTitle">
          {t("summaryquote.frequency")} {quoteDetails.frequency || ""}
         
          </p>
        </div>
        <div>
          <h2 className="text-[13px] lg:text-[12px] text-textTitle font-bold mb-2">
            Ubicacion
          </h2>
        
          <p className="mb-2 text-[12px] lg:text-[12px] font-semibold text-textTitle">
          {t("summaryquote.location")} {quoteDetails.location || ""}
        
          </p>
        </div>
      </div>

      <div className="bg-white w-full rounded-sm p-2 mb-4">
        <h2 className="text-[13px] lg:text-[12px] text-textTitle font-bold mb-2">
          {t("summaryquote.property")}
        </h2>
        <hr className="border-b-1 mb-4" />
        <div className="flex justify-between pr-4">
          <div>
            <p className="mb-2 text-[12px] font-semibold text-textTitle">
              {t("summaryquote.bedrooms")} {quoteDetails.bedrooms}
            </p>
            <p className="mb-2 text-[12px] font-semibold text-textTitle">
              {t("summaryquote.bathrooms")} {quoteDetails.bathrooms}
            </p>
            <p className="mb-2 text-[12px] font-semibold text-textTitle">
              {t("summaryquote.insideFridge")}{" "}
              {quoteDetails.insideFridge ? "Si" : "No"}
            </p>
          </div>
          <div>
            <p className="mb-2 text-[12px] font-semibold text-textTitle">
              {t("summaryquote.insideOven")}{" "}
              {quoteDetails.insideOven ? "Yes" : "No"}
            </p>
            <p className="mb-2 text-[12px] font-semibold text-textTitle">
              {t("summaryquote.insideCabinets")}{" "}
              {quoteDetails.insideCabinets ? "Yes" : "No"}
            </p>
            <p className="mb-2 text-[12px] font-semibold text-textTitle">
              {t("summaryquote.windows")} {quoteDetails.windows ? "Yes" : "No"}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-bgPrimary text-white rounded-lg text-center p-2">
        {t("summaryquote.price")} {quoteDetails.price}
      </div>
    </div>
  );
};

export default QuoteSummary;
